import { defaultBaseConfig } from '@chakra-ui/react/preset-base';
import { createSystem, defineConfig } from '@chakra-ui/react/styled-system';

import breakpoints from './breakpoints';
import globalCss from './global-css';
import animationStyles from './motion-styles';
import recipes from './recipes';
import semanticTokens from './semantic-tokens';
import slotRecipes from './slot-recipes';
import textStyles from './text-styles';
import tokens from './tokens';
import keyframes from './tokens/keyframes';

const themeConfig = defineConfig({
  preflight: true,
  cssVarsPrefix: '',
  cssVarsRoot: ':where(:root, :host)',
  globalCss,
  theme: {
    animationStyles,
    breakpoints,
    keyframes,
    recipes,
    semanticTokens,
    slotRecipes,
    textStyles,
    tokens,
  },
});

const bitkitTheme = createSystem(defaultBaseConfig, themeConfig);

export default bitkitTheme;
